module.exports = __webpack_public_path__ + "static/media/appStore.81df3c34.png";